/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_view_more__no_room = /** @type {(inputs: {}) => string} */ () => {
	return `Keine Verfügbarkeit`
};

const en_view_more__no_room = /** @type {(inputs: {}) => string} */ () => {
	return `No room available`
};

const es_view_more__no_room = /** @type {(inputs: {}) => string} */ () => {
	return `No hay disponibilidad`
};

const fr_view_more__no_room = /** @type {(inputs: {}) => string} */ () => {
	return `Pas de disponibilité`
};

const it_view_more__no_room = /** @type {(inputs: {}) => string} */ () => {
	return `Nessuna disponibilità`
};

const nl_view_more__no_room = /** @type {(inputs: {}) => string} */ () => {
	return `Geen beschikbaarheid`
};

const pt_view_more__no_room = /** @type {(inputs: {}) => string} */ () => {
	return `Sem disponibilidade`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const view_more__no_room = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.view_more__no_room(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("view_more__no_room", locale)
	if (locale === "de") return de_view_more__no_room(inputs)
	if (locale === "en") return en_view_more__no_room(inputs)
	if (locale === "es") return es_view_more__no_room(inputs)
	if (locale === "fr") return fr_view_more__no_room(inputs)
	if (locale === "it") return it_view_more__no_room(inputs)
	if (locale === "nl") return nl_view_more__no_room(inputs)
	return pt_view_more__no_room(inputs)
};